/* eslint-disable */
import ajax from "./../libs/ajax";

export default class {

  constructor(session) {
    this.session = session;
    this.loading = false;
  }

  _v5_services_url(uri) {
    let url = "https://services.phone.com";
    return `${url}${uri}`;
  }

  _get_auth_link(redirect_path, is_token) {
    const client_id = this.session.options.client_id;
    const state = Math.floor(Math.random() * 10000000);
    const redirect = `${document.location.protocol}//${document.location.host}${redirect_path}`;
    return `https://oauth.phone.com/?client_id=${client_id}&response_type=${is_token ? 'token' : 'code'}&scope=account-owner&redirect_uri=${encodeURIComponent(redirect)}&state=${state}`
  }

  phoenix_auth_headers(token) {
    return (this.session.user && this.session.user["token"]) || token
      ? [
        {
          name: "Authorization",
          value: token ? token : this.session.user["token"],
        },
      ]
      : [];
  }

  call_v5(uri, data) {
    this.loading = true;
    return new Promise((resolve, reject) => {
      ajax(
        "POST",
        this._v5_services_url(uri),
        data,
        this.phoenix_auth_headers()
      )
        .then((r) => {
          resolve(r.response);
        })
        .catch(reject)
        .finally(() => {
          this.loading = false;
        });
    });
  }

  get_billing_info() {
    return this.call_v5('/billing/invoice-details');
  }
}
